module.exports = __webpack_public_path__ + "static/media/service-scenario-bg5.5a848c4e.png";